import { render, staticRenderFns } from "./HospitalMobileItem.vue?vue&type=template&id=ce146b08"
import script from "./HospitalMobileItem.vue?vue&type=script&lang=js"
export * from "./HospitalMobileItem.vue?vue&type=script&lang=js"
import style0 from "./HospitalMobileItem.vue?vue&type=style&index=0&id=ce146b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports